import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { EventProvider } from "./lib/event";
import "./styles/index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <EventProvider>
      <App />
    </EventProvider>
  </StrictMode>,
);
